var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    id: "Company--Streamline-Flex",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Company Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "company--office-building-business",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 15.3V5.0a1.2 1.2 0 0 1 1.2 -1.2h5.4a1.2 1.2 0 0 1 1.2 1.2v10.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 15.3V8.2h3.0a1.2 1.2 0 0 1 1.2 1.2v5.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3 15.3h14.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0 6.6h1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0 6.6h1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0 9.2h1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0 9.2h1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0 11.0h1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 15.3v-2.5h1.6v2.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyStreamlineFlex);
export default __webpack_public_path__ + "static/media/Company--Streamline-Flex.77a409195c9fec5adda62270972ec17b.svg";
export { ForwardRef as ReactComponent };